import { manaSymbol } from '@/utils/symbolsMarkup.js'

export default {
	computed: {
		deckColors() {
			return this.sortedManaSymbols.map((color) => color.symbol)
		},
		sortedManaSymbols() {
			const colorCounts = {
				W: 0,
				U: 0,
				B: 0,
				R: 0,
				G: 0,
			}

			this.deck.cards.forEach((card) => {
				card.colors.forEach((color) => {
					if (color in colorCounts) {
						colorCounts[color] += card.qty
					}
				})

				const manaMatches = card.mana.match(/[WUBRG]/g)

				if (manaMatches) {
					manaMatches.forEach((symbol) => {
						colorCounts[symbol] += card.qty
					})
				}
			})

			const result = []

			for (const symbol in colorCounts) {
				if (colorCounts[symbol] > 0) {
					result.push({
						symbol,
						count: colorCounts[symbol],
					})
				}
			}

			return result.sort((a, b) => b.count - a.count)
		},
	},
	methods: {
		renderManaSymbols(deck) {
			if (deck.colors) {
				const sym = manaSymbol

				if (deck.colors.length > 0) {
					const getSymbolHTML = (color) => {
						switch (color) {
							case 'W':
								return sym.w
							case 'U':
								return sym.u
							case 'B':
								return sym.b
							case 'R':
								return sym.r
							case 'G':
								return sym.g
						}
					}

					return deck.colors.map((color) => getSymbolHTML(color)).join('')
				} else {
					return sym.c
				}
			} else {
				this.$store.commit('mutateActiveDeck', {
					colors: this.deckColors,
				})
			}
		},
		sizeManaSymbols(deck) {
			if (deck.colors) {
				const getClassName = () => {
					switch (deck.colors.length) {
						case 0: // Zero-mana decks show one mana symbol for colorless mana
						case 1:
							return 'one'
						case 2:
							return 'two'
						case 3:
							return 'three'
						case 4:
							return 'four'
						case 5:
							return 'five'
					}
				}

				return 'size-mana-symbols ' + getClassName()
			} else {
				this.$store.commit('mutateActiveDeck', {
					colors: this.deckColors,
				})
			}
		},
	},
}
